import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { baseModule } from '@/container-modules/base-module';
import { serviceApiModule } from '@/container-modules/service-api-module';
import { documentModule } from '@/container-modules/document-module';
import { biTrackModule } from '@eureka/domains';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    serviceApiModule,
    documentModule,
    biTrackModule
);

export {
    container,
};
